import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { resultFrom } from './result';

export interface IUser {
  email: string;
  name?: string;
  roles?: string[];
}

export interface IResponse {
  isOk: boolean;
  data?: IUser;
  message?: string;
}

export const defaultPath = '/';

@Injectable()
export class AuthService {
  private router = inject(Router);
  private http = inject(HttpClient);

  user = signal<IUser | null>(null);
  loggedIn = computed(() => !!this.user());

  private _lastAuthenticatedPath: string = defaultPath;

  set lastAuthenticatedPath(value: string) {
    console.log('Setting lastAuthenticatedPath', value);
    this._lastAuthenticatedPath = value;
  }

  async logIn(email: string, password: string) {
    const result = await resultFrom(
      this.http.post<{ email: string }>(`${environment.serviceUrl}/account/login`, { email, password }, { withCredentials: true })
    );

    if (!result.isSuccess) {
      console.error('Failed to log in', result);
      return result;
    }

    console.log('Logged in as', result);
    this.router.navigate([this._lastAuthenticatedPath]);

    return await this.getUser();
  }

  async getUser() {
    const result = await resultFrom(
      this.http.get<IUser>(`${environment.serviceUrl}/account/user`, {
        withCredentials: true
      })
    );

    if (result.isSuccess) {
      this.user.set(result.value);
      console.log('getUser', this.user());
    }

    return result;
  }

  hasRole(role: string) {
    return this.user().roles?.includes(role);
  }

  showMenu() {
    return this.loggedIn() && this.hasRole('Administrator');
  }

  async resetPassword(email: string) {
    try {
      // Send request

      return {
        isOk: true
      };
    } catch {
      return {
        isOk: false,
        message: 'Failed to reset password'
      };
    }
  }

  async logOut() {
    console.log('Logging out');
    await resultFrom(this.http.post(`${environment.serviceUrl}/account/logout`, {}, { withCredentials: true }));
    this.user.set(null);
    this.router.navigate(['/auth/login']);
  }
}
